import setFullbanner from './home/1_fullbanner';
import setCarousel from '../components/carousel';
import setCategoriesSwiper from './home/5_categories';
import { handleTabs, handleTabsSwipers } from './home/6_categoryTabs';
import setIcons from './home/4_icons';
import setInstagram from './home/2_instagram';
//addImports

const Home = {
  init: function () {
    setFullbanner();
    setCarousel();
    setCategoriesSwiper();
    handleTabs();
    handleTabsSwipers();
    setIcons();
    setInstagram();
    //calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
